export interface ILandingPromoURL {
	url: string;
	ownPage?: boolean;
	ownPageType?: "respo" | "mobilApp";
	img: string;
	buttonUrl?: string;
	trans: {
		[key: string]: {
			title: string;
			description: string;
			reviewBtn: string;
		};
	};
	respo?: {
		buttonUrl?: string;
		img: string;
		trans: {
			[key: string]: {
				title: string;
				description: string;
				reviewBtn: string;
			};
		};
	};
	mobilApp?: {
		buttonUrl?: string;
		img?: string;
		trans: {
			[key: string]: {
				title: string;
				description: string;
				reviewBtn: string;
			};
		};
	}
}

export const LANDING_PROMO_URLS: Array<ILandingPromoURL> = [
	{
		url: "restaurace",
		img: "realna-recenze_restaurace",
		trans: {
			cs: {
				title: "Kde mají guláš jako od maminky?",
				description: "Napište restauracím své hodnocení. A můžete přidat i aktuální fotky nabídky. Pomůžete tak ostatním dobře vybrat a příště zase inspirují oni vás.",
				reviewBtn: "Hodnotit restaurace",
			},
		},
	},{
		url: "pivovary",
		img: "realna-recenze_pivovar",
		trans: {
			cs: {
				title: "Kde mají pivo jako křen?",
				description: "Napište pivovarům své hodnocení. Můžete přidat i aktuální fotky z čepu. Pomůžete tak ostatním dobře vybrat a příště zase inspirují oni vás.",
				reviewBtn: "Hodnotit pivovary",
			},
		},
	},{
		url: "publictransport",
		ownPage: true,
		ownPageType: "mobilApp",
		img: "planovani-hd",
		trans: {
			cs: {
				title: "Všechny spoje v kapse",
				description: "Plánování dopravy v aplikaci Mapy.com jede na plný plyn. Odhalí zpoždění, zobrazí spoj přímo na mapě a navrhne trasu na míru – ať už vyrážíte s kočárkem po městě nebo s kolem do přírody.",
				reviewBtn: "Zůstat u plánování na webu",
			},
			en: {
				title: "All connections in your pocket",
				description: "Transport planning in the Mapy.com app is running at full speed. It reveals delays, shows your connection right on the map, and suggests a tailor-made route – whether you’re heading through the city with a stroller or off into nature with your bike.",
				reviewBtn: "Stay with planning on the web",
			},
		},
		respo: {
			img: "planovani-hd-respo",
			trans: {
				cs: {
					title: "Všechny spoje v kapse",
					description: "Plánujte trasu chytře a bez stresu. Aplikace Mapy.com vám prozradí zpoždění, ukáže spoj na mapě a navrhne cestu na míru.",
					reviewBtn: "Plánovat v aplikaci",
				},
				en: {
					title: "All connections in your pocket",
					description: "Plan your trip smartly and stress-free. The Mapy.com app tells you about delays, shows your connection on the map, and suggests a personalized route.",
					reviewBtn: "Plan in the app",
				},
			},
		},
		mobilApp: {
			buttonUrl: "https://mapy.com/?planovani-trasy&mrp={\"c\"%3A200%2C\"dt\"%3A\"\"%2C\"d\"%3Atrue}",
			img: "planovani-hd-respo",
			trans: {
				cs: {
					title: "Všechny spoje v kapse",
					description: "Plánujte trasu chytře a bez stresu. Aplikace Mapy.com vám prozradí zpoždění, ukáže spoj na mapě a navrhne cestu na míru. A když chcete víc pohodlí, přidá i trasu pro kočárek nebo s klimatizací.",
					reviewBtn: "Plánovat trasu",
				},
				en: {
					title: "All connections in your pocket",
					description: "Plan your trip smartly and stress-free. The Mapy.com app tells you about delays, shows your connection on the map, and suggests a personalized route. And if you want more comfort, it will even add routes for strollers or with air-conditioning. Whether you’re heading to work, into the city, or out into nature – with the app, travel is right at your fingertips.",
					reviewBtn: "Plan a route",
				},
			},
		},
	},
];
